export default __webpack_public_path__ + "static/media/orchid_tracking-green.06243f11.svg";